/* eslint-disable react/prop-types */
import React from 'react';
import { useHistory } from 'react-router-dom';
import { studentProfilePath } from './student_profile_path';

/** Opens the caller's profile from a live call pill so notes are two clicks away (PROD-10258). */
export default function StudentProfileLink({ studentUuid }) {
  const history = useHistory();
  if (!studentUuid) return null;
  const path = studentProfilePath(studentUuid);

  // Same-tab navigation keeps this tab's Twilio Device and the call; a modified click still opens a new tab.
  const onClick = (e) => {
    if (!history || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    e.preventDefault();
    history.push(path);
  };

  return (
    <a className="ocp-profile-link" href={path} onClick={onClick}>
      Open profile
    </a>
  );
}
